// import { observable } from 'mobx'

export default class BaseStore {}
